export function clipBoard(text: string) {
  navigator.clipboard.writeText(text);
}
